import * as actionTypes from "../actionType/action-type";

const initialState = { authToken: "" }
const AUTH_TOKEN = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.AUTH_TOKEN:
            return authToken(state, payload);
        default:
            return state;
    }
};

const authToken = (state, payload) => {
    let newState = {
        authToken: payload,
    };
    state = Object.assign({}, state, newState);
    return state;
};
export default AUTH_TOKEN;